import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaMedium, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const Experience = () => {
  const [openDropdown, setOpenDropdown] = useState(null);

  const experiences = [
    {
      text: 'Developed Terraform modules to automate custom model infrastructure on Amazon Bedrock, eliminating 100% of manual setup.',
      blogs: ['https://medium.com/searce/building-serverless-applications-with-aws-bedrock-2fa6d41cbfea']
    },
    {
      text: 'Deployed Palo Alto VM-Series firewalls with custom security rules, URL filtering, and IP policies; configured Active-Passive HA and designed Active-Active HA with Gateway Load Balancer, achieving 99% uptime and centralized management via Panorama.',
      blogs: [
        'https://medium.com/@adhirajmjarwal/palo-alto-firewall-deployment-on-aws-31e239070a20',
        'https://medium.com/@adhirajmjarwal/comprehensive-guide-to-security-profiles-in-palo-alto-networks-firewalls-6e26d26bfe2d',
        'https://medium.com/@adhirajmjarwal/deploying-active-passive-high-availability-for-palo-alto-vm-series-firewalls-in-aws-671358783deb',
        'https://medium.com/@adhirajmjarwal/deploying-palo-alto-vm-series-firewall-with-aws-gateway-load-balancer-ef449da0cd1b'
      ]
    },
    {
      text: 'Filtered 92% of hostile bot traffic and lowered critical vulnerabilities by 28% by engineering a multi-layer AWS WAF solution with custom ACLs, geo-blocking, and managed rules, fully integrated with Security Hub, GuardDuty, and Inspector.',
      blogs: [
        'https://medium.com/searce/implementing-traffic-control-with-alb-and-waf-blocking-specific-ips-while-allowing-general-access-4056fc4b394c',
        'https://medium.com/searce/implementing-aws-waf-to-restrict-access-based-on-country-61bae144d95d',
        'https://medium.com/@adhirajmjarwal/taming-the-bots-with-aws-waf-bot-control-on-alb-aa20d2a0ba0c'
      ]
    },
    {
      text: 'Delivered 3+ LLM-based applications (chatbots, summarizers, QnA agents) using Amazon Bedrock, Knowledge Bases, and Guardrails, enabling secure and scalable GenAI deployments with <300ms latency.',
      blogs: []
    },
    {
      text: 'Automated repeated notifications for 10+ critical CloudWatch alarms using EventBridge, Step Functions, and Lambda, reducing missed alerts by 60% through tag-based orchestration with AWS CDK.',
      blogs: ['https://medium.com/searce/enable-repeated-notifications-for-selective-cloudwatch-alarms-597c4d8a9ba8']
    },
    {
      text: 'Resolved security, networking, and system issues across Linux and Windows environments while performing OS patching and hardening, reducing incidents by 30% and improving overall system reliability.',
      blogs: []
    },
    {
      text: 'Executed automated, any-to-any workload migrations to GCP using RackWare RMM, orchestrating live replications to achieve cutover downtimes of less than one hour.',
      blogs: []
    }
  ];

  return (
    <motion.div 
      className="min-h-screen pt-32 pb-20"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="max-w-6xl mx-auto px-5">
        <motion.h1 
          className="text-4xl font-bold text-center mb-12"
          style={{ color: 'var(--color-primary-text)' }}
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          Professional Experience
        </motion.h1>
        
        <motion.div 
          className="grid grid-cols-1 xl:grid-cols-3 gap-8 mb-8"
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <div className="xl:col-span-3 backdrop-blur-md p-6 rounded-xl border-2" style={{ backgroundColor: 'var(--color-card-bg)', borderColor: 'var(--color-card-border)' }}>
          <h3 className="text-2xl font-bold mb-2" style={{ color: 'var(--color-primary-text)' }}>Cloud Engineer - Searce Inc</h3>
          <p className="font-semibold mb-6" style={{ color: 'var(--color-accent)' }}>January 2024 – Present | Hyderabad, India</p>
          <ul className="space-y-3">
            {experiences.map((exp, index) => (
              <li key={index} className="border rounded-lg p-3" style={{ borderColor: 'var(--color-card-border)' }}>
                <div className="flex items-start gap-3">
                  <button
                    onClick={() => setOpenDropdown(openDropdown === index ? null : index)}
                    className="mt-1 cursor-pointer hover:scale-110 transition-transform"
                    style={{ color: 'var(--color-accent)' }}
                  >
                    {openDropdown === index ? <FaChevronUp /> : <FaChevronDown />}
                  </button>
                  <span style={{ color: 'var(--color-primary-text)' }}>{exp.text}</span>
                </div>
                {openDropdown === index && exp.blogs.length > 0 && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    className="mt-3 ml-8 flex flex-wrap gap-2"
                  >
                    {exp.blogs.map((blog, blogIndex) => (
                      <a
                        key={blogIndex}
                        href={blog}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 px-3 py-1 rounded-lg hover:scale-105 transition-transform"
                        style={{ backgroundColor: 'var(--color-light-bg)', color: 'var(--color-accent)' }}
                      >
                        <FaMedium /> Blog {blogIndex + 1}
                      </a>
                    ))}
                  </motion.div>
                )}
              </li>
            ))}
          </ul>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Experience;